import { render, staticRenderFns } from "./report-mbsp.vue?vue&type=template&id=27a4db8c&scoped=true&"
import script from "./report-mbsp.vue?vue&type=script&lang=ts&"
export * from "./report-mbsp.vue?vue&type=script&lang=ts&"
import style0 from "./report-mbsp.vue?vue&type=style&index=0&id=27a4db8c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27a4db8c",
  null
  
)

export default component.exports